import { useState, useEffect } from 'react';

const prefixInit = 'leads_selected_app_';

const useApp = (props) => {
  const { uid = '' } = props || {};
  const prefix = props.prefix ? props.prefix : prefixInit;
  const [currentApp, setApp] = useState(() => {
    const init = sessionStorage.getItem(prefix + uid);

    if (!init || init == '' || init == undefined) {
      return '';
    }
    return init;
  });

  useEffect(() => {
    sessionStorage.setItem(prefix + uid, currentApp);
  }, [uid, currentApp]);

  return {
    currentApp,
    setApp,
  };
};

export default useApp;
